<template>
	<div>
		<div class="ModalPrompt" v-if="(variable||{}).id" >
			<h1>Edit the {{ variable.label }} variable</h1>
		</div>
		<div class="ModalPrompt" v-else >
			<h1>Add variable</h1>
		</div>
		<div class="ModalBody">
			<SimpleForm
				:autofocus="true"
				:onSubmit="onSubmit"
				:fields="fields"
				@change="onFormValsChange"
				:model="variable"
			/>
		</div>
	</div>
</template>

<script>

	import Variables from '../utils/Variables';


	export default {
		components : {
			// SimpleFormB,
		},
		props : [
			'variable',
			'variables',
			'onSubmit',
		],
		data(){
			return {
				moment,
				latest_type : null,
				defaultValueField : this.calculateDefaultField({type:'text'}),
			};
		},
		mounted() {
      Event.$emit('modal-draggable',true);
    },

		computed:{
			type_options(){
				return Variables.types().map( t => ({label:t.name,value:t.id}));
			},
			fields(){
				var self = this;
				return [
					{
						label : 'Field name',
						name : 'label',
						autocomplete : 'variable-label',
						autofocus : true,
						required : true,
						filterValue : this.filterNameValue,
						validateValue(val){
							if(val && self.variables.filter(x=>x.label==val&&x.lid!=self.variable.lid).length) return "A variable with that name already exists";
							return true;
						},
						label_help : 'Accepts alphanumeric characters and underscores.',
					},
					{
						label : 'Data type',
						name : 'type',
						type : 'select',
						required : true,
						options : this.type_options,
					},
					{
						label : 'Help prompt',
						label_help : 'Use this field to optionally add a prompt for people entering a value for this field, for example how to format or where to derive the value they enter.',
						placeholder : 'optional',
						name : 'prompt',
						type : 'textarea',
					},
					this.defaultValueField,
				];
			},
		},

		beforeMount(){
			this.variable = this.variable || {};
			this.variable.type = this.variable.type || 'text';
		},

		methods: {
			filterNameValue(value){
				return value.replace(/[^0-9a-zA-Z_]/gi, '').trim();
			},
			onFormValsChange(vals){
				if(vals.type == this.latest_type) return;

				this.latest_type = vals.type;
				this.defaultValueField = this.calculateDefaultField(vals);

				// If the value of default_value becomes invalidated as a result of 
				// changing the field type, clear it
				var dval = (vals||{})[this.defaultValueField.name];
				if(
					dval
					&& this.defaultValueField.validateValue
					&& !this.defaultValueField.validateValue(dval)
				){
					this.variable = {
						...vals,
						default_value : null,
					};
				}
			},
			calculateDefaultField({type,label}){
				var base = Variables.renderField({
					label : label||'default',
					type:type||'text',
				});

				return Object.assign(base,{
					label : 'Default value',
					placeholder : 'optional',
					name : 'default_value',
				})
			}
		}
	}
</script>